import './_jquery';

jQuery(function() {
  let fixedMenuHeight;
  fixedMenuHeight = 85.75;

  $('.google-map__box').on('click', 'a[href^="#"]', function() {
    let partnerID;
    partnerID = $.attr(this, 'href');

    $('.partners-list__row-item').removeClass('partners-list__row-item--selected');
    $(partnerID).addClass('partners-list__row-item--selected');
    $('html, body').animate({
      scrollTop: $(partnerID).offset().top - fixedMenuHeight
    }, 700);
  });

  if (document.location.hash.length > 1) {
    if (document.location.pathname.match(/^\/partner\//)) {
      $(document.location.hash).addClass('partners-list__row-item--selected');
      $(window).ready(function() {
        $('html, body').animate({
          scrollTop: $(document.location.hash).offset().top - fixedMenuHeight
        }, 700);
      });
    }
  }
});
